import { render } from "./use-rebuy.vue?vue&type=template&id=48506d84"
import script from "./use-rebuy.vue?vue&type=script&lang=js"
export * from "./use-rebuy.vue?vue&type=script&lang=js"

import "./use-rebuy.vue?vue&type=style&index=0&id=48506d84&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__